﻿import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';


import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';

import { JwtInterceptor, ErrorInterceptor } from './_interceptors';
import { HomeComponent } from './_components/public/home';
import { LoginComponent, ChangePasswordComponent, SocialComponent } from './_components/public/login';
import { RegisterComponent } from './_components/public/register';
import { AlertComponent } from './_components/alert';
import { RestComponent } from './_components/root/rest';
import { UsersComponent, EditUserComponent } from './_components/root/users';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ParamsComponent, EditParamComponent } from './_components/root/params';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ResultadosComponent, RecordComponent } from './_components/public/tablas';
import { ResultadoUserComponent } from './_components/user/tablas';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TablaComponent } from './_components/tabla';
import { CasaUserComponent } from './_components/user/tablas/casa.component';
import { CategoriaUserComponent } from './_components/user/tablas/categoria.component';
import { CategoriaDeporteUserComponent } from './_components/user/tablas/categoriaDeporte.component';
import { DeporteUserComponent } from './_components/user/tablas/deporte.component';
import { PuestoUserComponent } from './_components/user/tablas/puesto.component';
import { AlumnoUserComponent } from './_components/user/tablas/alumno.component';
import { SexoUserComponent } from './_components/user/tablas/sexo.component';
import { GradoUserComponent } from './_components/user/tablas/grado.component';
import { RecordUserComponent } from './_components/user/tablas/record.component';
import { RouterModule } from '@angular/router';
import { HomeRootComponent } from './_components/root/home';
import { InterHousesUserComponent } from './_components/user/tablas/interhouses.component';
import { CargarResultadoComponent } from './_components/user/cargarResultado/cargar.resultado.component';
import { ResumenComponent } from './_components/user/resumen/resumen.component';
import { CargarInterHousesUserComponent } from './_components/user/tablas/cargar.interhouses.component';
import { PuntosComponent } from './_components/user/puntos/puntos.component';
import { RootResultadoComponent } from './_components/root/resultado/resultado.component';
import { GradoRootComponent } from './_components/root/grado';
import { CargarInterhouseComponent } from './_components/user/cargarInterhouse/cargar.interhouse.component';


@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        FormsModule,
        RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' , useHash: true}),
        BlockUIModule.forRoot(),
        BlockUIHttpModule.forRoot(),
        BrowserAnimationsModule,
        NgxJsonViewerModule,
        NgxDatatableModule
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        RestComponent,
        UsersComponent,
        EditUserComponent,
        ChangePasswordComponent,
        SocialComponent,
        ParamsComponent,
        EditParamComponent,
        ResultadosComponent,
        ResultadoUserComponent,
        TablaComponent,
        CasaUserComponent,
        CategoriaUserComponent,
        CategoriaDeporteUserComponent,
        DeporteUserComponent,
        PuestoUserComponent,
        AlumnoUserComponent,
        SexoUserComponent,
        GradoUserComponent,
        RecordComponent,
        RecordUserComponent,
        HomeRootComponent,
        InterHousesUserComponent,
        CargarResultadoComponent,
        ResumenComponent,
        CargarInterHousesUserComponent,
        PuntosComponent,
        RootResultadoComponent,
        GradoRootComponent,
        CargarInterhouseComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // provider used to create fake backend
        // fakeBackendProvider
    ],
    bootstrap: [AppComponent],
    exports: [RouterModule]

})

export class AppModule { }
